import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="dynamic_select"
export default class extends Controller {
  static targets = ["option"];
  connect() {
    console.log('connected')
  }
}
